<script>
    import { onMount } from 'svelte';
    import TimeSlotComponent from './TimeSlotComponent.svelte'
    import TimeSlotInputComponent from './TimeSlotInputComponent.svelte';
    import FilterButtonsForSettingsPage from './FilterButtonsForSettingsPage.svelte';
    import NavBarReusable from './NavbarReusable.svelte';
    import TeachingStartDateComponent from './TeachingStartDateComponent.svelte';
    
    window.csrfToken = "{{ csrf_token }}";
    const getCsrfToken = () => {
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken='));
        return csrfToken ? csrfToken.split('=')[1] : '';
    };

    const deleteTimeSlot = async(timeslot) => {
        const token = localStorage.getItem('jwtToken');
        const load = {
            timeslot_id: timeslot[4] // Use the timeslot ID for deletion
        };

        try {
            
        const response = await fetch('/studentplayground/delete-timeslot/', {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(load)
        });

        if (response.ok) {
            // Small delay to ensure backend has processed the deletion
            setTimeout(() => {
                fetchUserTimeslots();
            }, 100);
        } else {
            alert('Failed to delete timeslot');
        }
        } catch (error) {
        alert('Error deleting timeslot');
        }
    };



    let userTimeSlots = [];
    let teachingStartDate = '';
    let refreshTrigger = 0; // Add a trigger to force reactivity
    let isUserTeacher = false; // Track if the logged-in user is a teacher
    
    // Reactive statement to force re-render when data changes
    $: displayTimeSlots = refreshTrigger >= 0 ? userTimeSlots.map((slot, index) => [...slot, index]) : [];
    


    // Function to check if user is a teacher
    const checkIfUserIsTeacher = async () => {
        const token = localStorage.getItem('jwtToken');
        
        try {
            const response = await fetch('/studentplayground/isUserTeacher/', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                isUserTeacher = data.isUserTeacher;
            } else {
                console.error('Failed to check teacher status');
                isUserTeacher = false;
            }
        } catch (error) {
            console.error("Failed to fetch user role:", error);
            isUserTeacher = false;
        }
    };

    const fetchUserTimeslots = async () => {
        const token = localStorage.getItem('jwtToken')
    
        try {
        const response = await fetch('/studentplayground/settings/', {
            method: 'GET',
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            }
        });

        if (response.ok) {
            const data = await response.json();
            
            // Force reactivity by clearing and reassigning
            userTimeSlots = [];
            userTimeSlots = data.user_timeslots;
            teachingStartDate = data.teaching_start_date || '';
            refreshTrigger++; // Trigger reactive update
        } else {
            if (response.status === 401) {
                // If response is 401 Unauthorized, redirect to login
                alert('Reikia prisijungti iš naujo.');
                localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                window.location.href = '#/about'; // Redirect to login page
            } else {
                // Handle other errors
                alert('Error loading settings page');
            }
            } 
        } catch (error) {
        console.error("Failed to fetch user role:", error);
        return null;
        }
    };
    onMount(async () => {
        await checkIfUserIsTeacher();
        await fetchUserTimeslots();
    })

</script>

<NavBarReusable label="Mano Profilis" />
<FilterButtonsForSettingsPage
 currentFilter='Laisvi laikai' >
 </FilterButtonsForSettingsPage>
{#if isUserTeacher}
<div class="classcontainer">
    <TeachingStartDateComponent teachingStartDate={teachingStartDate} />
</div>
{/if}

<div class="classcontainer">
    <TimeSlotInputComponent></TimeSlotInputComponent>
    <h2>Užregistruoti laisvi laikai</h2>
    {#each displayTimeSlots as timeslot, index (timeslot[4])}
        <TimeSlotComponent 
            timeslot={timeslot} 
            onRemove={() => deleteTimeSlot(timeslot)} 
        />
  {/each}
</div>

<style>
    
    .classcontainer {
      padding: 15px;
      background-color: #eeebdb;
      display: flex;
      flex-direction: column;
      margin-bottom: 15px;
      gap: 10px;
      box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
      border-radius: 8px;
      color: black;
      align-items: flex-start;
    }
    
</style>